import React from "react";
import FormOptionInput from "../FormOptionInput";
import FormOptionRadio from "../FormOptionRadio";
import FormOptionBtn from "../FormOptionsBtn";
import FormOptionDynamicDropdown from "../FormOptionDynamicDropdown";
import FormOptionCheckbox from "../FormOptionCheckbox";
import { Radio } from "antd";
import trans, { isRTL } from "../../../../../utils";
import FormOptionGroupConfig from "../FormOptionGroupConfig";
import FormOptionDerived from "../FormOptionDerived";
import FormOptionComputed from "../FormOptionComputed";
import FormOptionVisibility from "../FormOptionVisibility";
import { getSiblingFields } from "../../../formScope";

export default function FormOptionMain({
	activeInput,
	activeItem,
	updateActiveItem,
	setOthers,
	others,
	addForm,
	submitAttempt,
	localErrors,
	setLocalErrors,
}) {
	const activeIndex = addForm.values.formSchema.fields.findIndex(
		(field) => field.key === activeItem.key
	);

	let containerIndex = null;
	let innerIndex = null;
	let groupIndex = null;
	let groupInnerIndex = null;
	let containerTitle = null;
	let containerImg = null;
	let containerLink = null;
	let groupTitle = null;
	let groupImg = null;
	let groupLink = null;

	addForm.values.formSchema.fields.forEach((field, i) => {
		if (field.name === "Container") {
			const indexInside = field.container?.findIndex(
				(j) => j.key === activeItem.key
			);
			if (indexInside !== -1) {
				containerIndex = i;
				innerIndex = indexInside;
				containerTitle = field.container[indexInside]?.title;
				containerImg = field.container[indexInside]?.imgPath;
				containerLink = field.container[indexInside]?.hyperLink;
			}
		}

		if (field.name === "RepeatingGroup") {
			const indexInside = field.fields?.findIndex(
				(j) => j.key === activeItem.key
			);
			if (indexInside !== -1) {
				groupIndex = i;
				groupInnerIndex = indexInside;
				groupTitle = field.fields[indexInside]?.title;
				groupImg = field.fields[indexInside]?.imgPath;
				groupLink = field.fields[indexInside]?.hyperLink;
			}
		}
	});
	const siblingFields = getSiblingFields(
		addForm.values.formSchema,
		activeItem.key
	);

	const titleFromFormik =
		addForm.values.formSchema.fields[activeIndex]?.title ??
		containerTitle ??
		groupTitle;
	const ImgFromFormik =
		addForm.values.formSchema.fields[activeIndex]?.imgPath ??
		containerImg ??
		groupImg;
	const LinkFromFormik =
		addForm.values.formSchema.fields[activeIndex]?.hyperLink ??
		containerLink ??
		groupLink;
	const showInitialName = !titleFromFormik && titleFromFormik !== "";

	function getFieldMeta(fieldName) {
		const isInContainer = containerIndex !== null;
		const isInGroup = groupIndex !== null;

		let path;
		if (isInContainer) {
			path = `formSchema.fields[${containerIndex}].container[${innerIndex}]`;
		} else if (isInGroup) {
			path = `formSchema.fields[${groupIndex}].fields[${groupInnerIndex}]`;
		} else {
			path = `formSchema.fields[${activeIndex}]`;
		}

		const fullPath = fieldName.includes(".")
			? `${path}.${fieldName}`
			: `${path}.${fieldName}`;

		const getBaseObj = (source) => {
		if (isInContainer) {
			return source?.formSchema?.fields?.[containerIndex]?.container?.[innerIndex];
		}
		if (isInGroup) {
			return source?.formSchema?.fields?.[groupIndex]?.fields?.[groupInnerIndex];
		}
		return source?.formSchema?.fields?.[activeIndex];
	};

	const value = fieldName
			.split(".")
			.reduce((obj, key) => obj?.[key], getBaseObj(addForm.values));

		const error = fieldName
			.split(".")
			.reduce((obj, key) => obj?.[key], getBaseObj(addForm.errors));

		const touched = fieldName
			.split(".")
			.reduce((obj, key) => obj?.[key], getBaseObj(addForm.touched));

		return {
			value,
			error,
			touched,
			path: fullPath,
		};
	}

	const titleMeta = getFieldMeta("title");

	// Conditional meta getters (only call when needed)
	const hyperLinkMeta =
		activeItem.name === "Link" ? getFieldMeta("hyperLink") : null;

	const imgPathMeta =
		activeItem.name === "Image" ? getFieldMeta("imgPath") : null;
	const validationMeta =
		activeItem.required && typeof activeItem.required === "object"
			? getFieldMeta("required.validationMessage")
			: null;

	const handleBlur = (path) => {
		addForm.setFieldTouched(path, true, true);
	};
	return (
		<div className="field-settings-panel">
			<div className="field-settings-header">
				<h3 style={{ textAlign: isRTL ? "right" : "left" }}>
					{trans("Field Settings")}
				</h3>
			</div>
			<div className="field-settings-key" title={activeInput || undefined}>
				<span className="field-settings-key-label">{trans("Key")}</span>
				<span className="field-settings-key-value">
					{activeInput || trans("No input selected")}
				</span>
			</div>

			{activeItem.name !== "Container" && activeItem.name !== "Image" && (
				<FormOptionInput
					title={trans("Title")}
					placeholder={trans("Enter input title")}
					name={titleMeta.path}
					id={titleMeta.path}
					value={showInitialName ? activeItem.name : titleFromFormik}
					onChange={(e) => {
						updateActiveItem("title", e.target.value);
						addForm.handleChange(e);
					}}
					onBlur={() => handleBlur(titleMeta.path)}
					errors={!showInitialName && titleMeta.touched && titleMeta.error}
					touched={!showInitialName && titleMeta.touched}
				/>
			)}

			{(activeItem.name === "Input" ||
				activeItem.name === "Text_area" ||
				activeItem.name === "Dropdown" ||
				activeItem.name === "MultiSelect") && (
				<FormOptionInput
					title={trans("Placeholder")}
					placeholder={trans("Enter input placeholder")}
					value={activeItem.placeholder}
					onChange={(e) => updateActiveItem("placeholder", e.target.value)}
				/>
			)}

			{activeItem.name === "Input" && (
				<div className="task-option-item">
					<label htmlFor={activeItem.name} className="form-label">
						{trans("Input Type")}
					</label>
					<Radio.Group
						style={{ display: "flex", flexDirection: "row", gap: 24 }}
						value={activeItem.inputType}
						onChange={(e) => updateActiveItem("inputType", e.target.value)}
						options={[
							{ label: trans("Text"), value: "text" },
							{ label: trans("Number"), value: "number" },
						]}
					/>
				</div>
			)}

			{activeItem.name === "Link" && (
				<FormOptionInput
					title={trans("Link")}
					placeholder={trans("Enter hyperLink")}
					name={hyperLinkMeta.path}
					id={hyperLinkMeta.path}
					value={LinkFromFormik || ""}
					onChange={(e) => {
						updateActiveItem("hyperLink", e.target.value);
						addForm.handleChange(e);
					}}
					onBlur={() => handleBlur(hyperLinkMeta.path)}
					errors={hyperLinkMeta.touched && hyperLinkMeta.error}
					touched={hyperLinkMeta.touched}
				/>
			)}

			{activeItem.name === "Image" && (
				<FormOptionInput
					title={trans("Image Link")}
					placeholder={trans("Enter Image Link")}
					name={imgPathMeta.path}
					id={imgPathMeta.path}
					value={ImgFromFormik || ""}
					onChange={(e) => {
						updateActiveItem("imgPath", e.target.value);
						addForm.handleChange(e);
					}}
					onBlur={() => handleBlur(imgPathMeta.path)}
					errors={imgPathMeta.touched && imgPathMeta.error}
					touched={imgPathMeta.touched}
				/>
			)}

			{![
				"Toggle",
				"Button",
				"Checkbox",
				"Container",
				"Image",
				"Header",
				"Label",
				"Link",
				"Progress_line",
				"Progress_circle",
			].includes(activeItem.name) && (
				<>
					<FormOptionCheckbox
						title={trans("Required")}
						id={activeItem?.key}
						value={activeItem?.required?.value}
						onChange={(e) =>
							updateActiveItem("required.value", e.target.checked)
						}
					/>

					{activeItem.required?.value && (
						<FormOptionInput
							title={trans("Validation Message")}
							placeholder={trans("Enter validation message")}
							name={validationMeta.path}
							id={validationMeta.path}
							value={trans(validationMeta.value)}
							onChange={(e) => {
								updateActiveItem("required.validationMessage", e.target.value);
								addForm.handleChange(e);
							}}
							onBlur={() => handleBlur(validationMeta.path)}
							errors={validationMeta.touched && validationMeta.error}
							touched={validationMeta.touched}
						/>
					)}
				</>
			)}

			{activeItem.name === "Radio_group" && (
				<FormOptionRadio
					id={activeItem?.key}
					radioOptions={activeItem?.radioOptions}
					onChange={(e) => updateActiveItem("radioOptions", e.target.value)}
					addForm={addForm}
					setLocalErrors={setLocalErrors}
					localErrors={localErrors}
				/>
			)}

			{activeItem.name === "Button" && (
				<FormOptionBtn
					id={activeItem?.key}
					onChange={(e) => updateActiveItem("btnType", e.target.value)}
				/>
			)}

			{(activeItem.name === "Dropdown" || activeItem.name === "MultiSelect") && (
			<FormOptionDynamicDropdown
				id={activeItem?.key}
				dropdownOptions={activeItem?.dropdownOptions}
				queryKey={activeItem?.dropdownOptions?.queryKey || "static"}
				setOthers={setOthers}
				others={others}
				onChange={(e) => updateActiveItem("dropdownOptions", e.target.value)}
				addForm={addForm}
				setLocalErrors={setLocalErrors}
				localErrors={localErrors}
				activeItem={activeItem}
				siblingFields={siblingFields}
			/>
		)}

		{activeItem.name === "RepeatingGroup" && (
			<FormOptionGroupConfig
				activeItem={activeItem}
				updateActiveItem={updateActiveItem}
			/>
		)}

		{(activeItem.name === "Dropdown" || activeItem.name === "MultiSelect" || activeItem.name === "Input" || activeItem.name === "Text_area" || activeItem.name === "Checkbox" || activeItem.name === "Toggle" || activeItem.name === "Radio_group" || activeItem.name === "DatePicker" || activeItem.name === "DateTime" || activeItem.name === "Camera" || activeItem.name === "Uploader" || activeItem.name === "Signature" || activeItem.name === "DerivedValue" || activeItem.name === "ComputedValue") && (
			<FormOptionVisibility
				activeItem={activeItem}
				siblingFields={siblingFields}
				updateActiveItem={updateActiveItem}
			/>
		)}

		{activeItem.name === "DerivedValue" && (
			<FormOptionDerived
				activeItem={activeItem}
				siblingFields={siblingFields}
				updateActiveItem={updateActiveItem}
			/>
		)}

		{activeItem.name === "ComputedValue" && (
			<FormOptionComputed
				activeItem={activeItem}
				siblingFields={siblingFields}
				updateActiveItem={updateActiveItem}
			/>
		)}

		{activeItem.name === "Container" &&
			(!activeItem.container || activeItem.container.length === 0) &&
			submitAttempt && (
				<div className="text-danger" style={{ marginTop: 4, fontSize: 12 }}>
					{trans("Container must have at least one input")}
				</div>
			)}
		</div>
);
}
